export default __webpack_public_path__ + "static/media/solution.e338478a.svg";